import { render } from "./ArchiveChart.vue?vue&type=template&id=5a1bde39&scoped=true"
import script from "./ArchiveChart.vue?vue&type=script&lang=js"
export * from "./ArchiveChart.vue?vue&type=script&lang=js"

import "./ArchiveChart.vue?vue&type=style&index=0&id=5a1bde39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1bde39"]])

export default __exports__